// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"11":"e72c4ba1","208":"2ceba794","233":"8ac9c7d5","260":"be3bfc4f","369":"04860a0f","390":"1eb87162","547":"8e04fe23","675":"b4b15c24"}[chunkId] + ".js";
};